import { Card, formatPersianNumber } from '../../../app/components/foundation';
import { ControlPlaneDataSurface, ControlPlaneMetricStrip, ControlPlaneSection } from '../../../app/components/foundation/control-plane';
import type { SettingsOverview } from '../types/settings.types';

interface SettingsLiveOverviewProps {
  settings: SettingsOverview;
}

export function SettingsLiveOverview({ settings }: SettingsLiveOverviewProps) {
  const services = Object.entries(settings.system.service_configuration);

  return (
    <>
      <ControlPlaneMetricStrip
        className="vania-settings-summary-strip"
        items={[
          { label: 'محیط اجرا', value: settings.system.environment },
          { label: 'نسخه Python', value: <span dir="ltr">{settings.system.python_version}</span> },
          { label: 'کل تننت‌ها', value: formatPersianNumber(settings.tenant.total) },
          { label: 'تننت‌های فعال', value: formatPersianNumber(settings.tenant.active), tone: 'success' },
        ]}
      />
      <ControlPlaneSection title="پیکربندی سرویس‌ها">
        <Card className="vania-settings-section-card">
          {services.map(([name, configured]) => <p key={name}>{name}: {configured ? 'پیکربندی شده' : 'پیکربندی نشده'}</p>)}
        </Card>
      </ControlPlaneSection>
      <ControlPlaneSection title="پروفایل سوپر ادمین">
        <Card className="vania-settings-section-card">
          <p>{settings.admin.profile.full_name}</p>
          <p dir="ltr">{settings.admin.profile.mobile}</p>
          <p>وضعیت نشست: فعال</p>
        </Card>
      </ControlPlaneSection>
      <ControlPlaneSection title="داده‌های تننت">
        <ControlPlaneDataSurface>
          <div className="vania-settings-table-scroll"><table className="vania-settings-table"><thead><tr><th>نام</th><th>شناسه</th><th>وضعیت</th></tr></thead><tbody>
            {settings.tenant.items.map((tenant) => <tr key={tenant.id}><td>{tenant.name}</td><td dir="ltr">{tenant.slug}</td><td>{tenant.is_active === 1 ? 'فعال' : 'غیرفعال'}</td></tr>)}
          </tbody></table></div>
        </ControlPlaneDataSurface>
      </ControlPlaneSection>
      <ControlPlaneSection title="خلاصه‌های نهایی">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <Card className="vania-settings-section-card"><h2 className="mb-3 text-lg font-semibold">Roles و Permissions</h2><p>نقش‌ها: {formatPersianNumber(settings.permissions.roles.length)}</p><p>مجوزها: {formatPersianNumber(settings.permissions.permissions.length)}</p></Card>
          <Card className="vania-settings-section-card"><h2 className="mb-3 text-lg font-semibold">Feature Flags و Service Toggles</h2><p>Feature Flags: {formatPersianNumber(settings.application.feature_flags.length)}</p><p>Client Apps: {settings.application.service_toggles.client_apps.configured ? 'پیکربندی شده' : 'غیرفعال'}</p></Card>
        </div>
      </ControlPlaneSection>
    </>
  );
}
